import { render, staticRenderFns } from "./AccountSection.vue?vue&type=template&id=c0475fbc"
import script from "./AccountSection.vue?vue&type=script&lang=js"
export * from "./AccountSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports